// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"code-off"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19.5001 14.5006L21.9998 11.9996L18.4643 8.4641M6.99981 7.00043L2 12.0002L5.53553 15.5358","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M4 4.00049L20 20.0005","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-code-off')
export default class CodeOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'code-off',
    }
  }
}
